import React from 'react';
import { FormattedMessage } from 'react-intl';

export const JRCWidgetEmailsImapEditor = () => {
    return <FormattedMessage id="PANEL_Widget_Empty_Setting" />;
};
